import {FetchFunction} from '../types'
import {addHeaders} from '../utils'

const getTimezone = (function tryTimezone() {
  let timezone: string | undefined

  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  } catch (e) {}

  return function _getTimezone(): string | undefined {
    return timezone
  }
})()

export const withTimezone =
  <TReq = unknown, TRes = unknown>(fetchFunc: FetchFunction<TReq, TRes>): FetchFunction<TReq, TRes> =>
  config => {
    const headers: Record<string, string> = {}

    const timezone = getTimezone()

    if (timezone) {
      headers['Timezone'] = timezone
    }

    return fetchFunc(addHeaders(config, headers))
  }
